<template>
  <div class="add-type-modal">
    <el-dialog
      :title="modalType === 'edit' ? '编辑类型' : '新建类型'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form
        :rules="rules"
        :model="ruleForm"
        ref="ruleForm"
        label-width="90px"
        class="demo-dynamic"
      >
        <el-form-item v-if="modalType === 'add'">
          <el-button @click="addItem" icon="el-icon-plus" style="width: 290px">添加类型</el-button>
        </el-form-item>
        <el-form-item prop="typeId" label="类型：">
          <el-select style="width: 290px" v-model="ruleForm.typeId" placeholder="请选择类型">
            <el-option
              v-for="item in platformList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="content">
          <el-form-item
            label=" "
            class="label-body"
            prop="typeList"
            :rules="{
              required: true,
              trigger: 'blur',
              validator: labelValidator,
            }"
          >
            <el-form-item
              v-for="(item, index) in ruleForm.typeList"
              class="form-item marginLeft"
              :label="index === 0 ? '类型名称：' : ''"
              :key="index"
              :prop="'typeList.' + index + '.value'"
              :rules="{
                required: true,
                message: '类型名称不能为空',
                trigger: 'blur',
              }"
            >
              <el-input
                type="text"
                placeholder="请输入类型名"
                v-model="item.value"
                maxlength="20"
                show-word-limit
              ></el-input>
              <i
                class="el-icon-delete icon"
                v-if="ruleForm.typeList.length > 1"
                @click.prevent="deleteItem(index)"
              ></i>
            </el-form-item>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { modifyTagProperty, addTagProperty, getPlatformType } from "@/api/property.js";
export default {
  components: {},

  data() {
    return {
      dialogVisible: false,
      ruleForm: {},
      rules: {
        typeId: [{ required: true, message: "请输入类型", trigger: "change" }],
      },
      loading: false,
      modalType: "",
      platformList: [],
    };
  },
  methods: {
    labelValidator(rule, value, callback) {
      console.log(value);
      const list = value.map((item) => item.value);
      if (new Set(list).size !== list.length && !list.includes("")) {
        callback(new Error("添加的类型不能重复"));
      } else {
        callback();
      }
    },
    openModal(type, row) {
      this.modalType = type;
      if (this.modalType === "add") {
        this.ruleForm = {
          typeList: [{ value: "" }],
          typeId: "",
        };
      } else {
        const { type, name, id } = row;
        this.ruleForm = {
          id,
          typeId: type,
          typeList: [{ value: name }],
        };
      }
      getPlatformType().then((res) => {
        this.platformList = res.data.map((item) => {
          return {
            ...item,
            id: parseInt(item.id)
          }
        });
      });
      this.dialogVisible = true;
      this.$refs.ruleForm?.clearValidate();
    },
    addItem() {
      this.ruleForm.typeList.push({ value: "" });
    },
    deleteItem(index) {
      this.ruleForm.typeList.splice(index, 1);
    },
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { typeId, typeList, id } = this.ruleForm;
          if (this.modalType === "edit") {
            modifyTagProperty({
              id,
              type: typeId,
              names: typeList.map((item) => item.value),
            }).then((res) => {
              if (res.code === "0000") {
                this.dialogVisible = false;
                this.$message.success("编辑成功");
                this.$emit("callBackSuccess");
              }
            });
          } else {
            addTagProperty({
              type: typeId,
              names: typeList.map((item) => item.value),
            }).then((res) => {
              if (res.code === "0000") {
                this.dialogVisible = false;
                this.$message.success(this.modalType === "add" ? "添加成功" : "复制成功");
                this.$emit("callBackSuccess");
              }
            });
          }
        } else {
          // this.$message.error("表单未填写完成");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-type-modal {
  .content {
    max-height: 500px;
    overflow: auto;
    margin-top: 12px;
    padding-right: 12px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }
    .form-item {
      /deep/ .el-input {
        width: 290px;
      }
      .icon {
        font-size: 20px;
        margin-left: 12px;
        margin-top: 7px;
        cursor: pointer;
      }
      .el-icon-delete {
        color: red;
      }
    }
    .label-body {
      /deep/ .el-form-item__content {
        margin-left: 0px !important;
      }
      /deep/ .el-form-item__error {
        margin-left: 90px;
      }
    }
    .marginLeft {
      /deep/ .el-form-item__content {
        margin-left: 90px !important;
      }
      /deep/ .el-form-item__error {
        margin-left: 0px;
      }
    }
  }
}
</style>
